import React from "react";

export const Disclaimer: React.FC<{}> = () => (
  <div className="text-black-2 text-xs md:text-base text-semibold leading-normal mt-10">
    <h3 className="font-bold text-base md:text-xl leading-5 text-black mb-8">
      Jakie leki stosować w przypadku gorączki?
    </h3>
    <p className="mb-4">
      <span className="font-extrabold">Ibuprofen</span> – jest lekiem
      przeciwbólowym, przeciwgorączkowym i przeciwzapalnym
    </p>
    <ul className="list-disc pl-4 mb-4 text-xxs md:text-s">
      <li className="text-blue-3">
        <div className="text-black-2">
          może być stosowany po 3. miesiącu życia dziecka
        </div>
      </li>
      <li className="text-blue-3">
        <div className="text-black-2">
          dawkowanie 5-10 mg/kg masy ciała co 6-8 godzin
        </div>
      </li>
      <li className="text-blue-3">
        <div className="text-black-2">
          Uwaga! Przeciwwskazany w ospie wietrznej (zwiększa ryzyko nadkażeń
          bakteryjnych)
        </div>
      </li>
    </ul>
    <p className="mb-4">
      <span className="font-extrabold">Paracetamol</span> – jest lekiem
      przeciwbólowym i przeciwgorączkowym
    </p>
    <ul className="list-disc pl-4 mb-8 text-xxs md:text-s">
      <li className="text-blue-3">
        <div className="text-black-2">
          może być stosowany od pierwszych dni życia dziecka
        </div>
      </li>
      <li className="text-blue-3">
        <div className="text-black-2">
          dawkowanie 10-15 mg/kg masy ciała co 4-6 godzin
        </div>
      </li>
    </ul>
    <h3 className="font-bold text-base md:text-xl leading-5 text-black mb-8">
      Ważne!
    </h3>
    <p className="font-extrabold mb-4">
      Stężenie 20mg/ml jest równoznaczne ze stężeniem 100mg/5ml. 5x20mg=100mg
    </p>
    <p className="font-extrabold mb-4">
      Stężenie 40mg/ml jest równoznaczne ze stężeniem 200mg/5ml. 5x40mg=200mg
    </p>
    <p className="font-normal">
      Ten sam lek może kryć się pod różnymi nazwami. Np. Apap, Panadol, Calpol,
      Eferalgan to wszystko paracetamol. Nurofen, Ibum, Ibuprom to ibuprofen.
      Pamiętaj o tym!
    </p>
  </div>
);
